import dayjs from 'dayjs';

const copyToClipboard = async (text) => {
  if (navigator.clipboard?.writeText) {
    await navigator.clipboard.writeText(text);
    return true;
  }
  try {
    const textarea = document.createElement('textarea');
    textarea.value = text;
    document.body.appendChild(textarea);
    textarea.select();
    const ok = document.execCommand('copy');
    document.body.removeChild(textarea);
    return ok;
  } catch (_err) {
    return false;
  }
};

const safeJsonStringify = (value) => {
  const seen = new WeakSet();
  try {
    return JSON.stringify(
      value,
      (_key, val) => {
        if (typeof val === 'bigint') return val.toString();
        if (typeof val === 'function') return '[function]';
        if (!val || typeof val !== 'object') return val;
        if (seen.has(val)) return '[circular]';
        seen.add(val);
        return val;
      },
      0
    );
  } catch (_err) {
    try {
      return String(value);
    } catch (_err2) {
      return '';
    }
  }
};

const safeExportValue = (value) => {
  if (value === null || value === undefined) return '';
  if (value instanceof Date) {
    const t = value.getTime();
    return Number.isNaN(t) ? '' : value.toISOString();
  }
  const t = typeof value;
  if (t === 'string' || t === 'number' || t === 'boolean') return value;
  if (Array.isArray(value)) {
    if (value.length === 0) return '';
    const allPrimitive = value.every(
      (item) => item === null || item === undefined || ['string', 'number', 'boolean'].includes(typeof item)
    );
    if (allPrimitive) return value.filter((v) => v !== null && v !== undefined).join(', ');
    return safeJsonStringify(value);
  }
  if (t === 'object') return safeJsonStringify(value);
  try {
    return String(value);
  } catch (_err) {
    return '';
  }
};

const safeTsvCell = (value) => {
  const normalized = safeExportValue(value);
  if (typeof normalized === 'string') return normalized.replace(/\t/g, ' ').replace(/\r?\n/g, '\\n');
  return normalized;
};

const formatVmtDateValue = (value) => {
  if (value === null || value === undefined || value === '') return '';
  const parsed = dayjs(String(value).trim());
  if (!parsed.isValid()) return String(value).trim();
  return parsed.format('YYYY-MM-DD');
};

export {
  copyToClipboard,
  safeJsonStringify,
  safeExportValue,
  safeTsvCell,
  formatVmtDateValue,
};
